import styled from "styled-components";

import { DateTime } from "luxon";

import FnrIcon from "UI/FnrIcon";

import { formatNumberWithCommas } from "Utilities/Number";

import { ActionButtonLayout } from "../../ActionButton";

export default function GiftData({ amount, nextGiftDate, status }) {
  const nextDate = DateTime.fromISO(nextGiftDate);
  const now = DateTime.now();

  let nextDateString;

  if (!nextDate.isValid || !now.isValid) {
    nextDateString = "on N/A";
  } else {
    const thisWeek = nextDate.diff(now, ["days"]).toObject().days <= 6;

    if (thisWeek) {
      if (nextDate.diff(now, ["days"]).toObject().days <= 1)
        nextDateString = "tomorrow";
      else nextDateString = `on ${nextDate.toFormat("EEEE")}`;
    } else {
      const includeYear = now.toFormat("YYYY") !== nextDate.toFormat("YYYY");
      nextDateString = `on ${nextDate.toFormat(
        `MMMM dd${includeYear ? " YYYY" : ""}`
      )}`;
    }
  }

  return (
    <ActionButtonLayout>
      <Wrapper>
        {status === "Paused" && (
          <PausedIcon>
            <FnrIcon fas fa-pause />
          </PausedIcon>
        )}
        <Text>
          Your next gift of ${formatNumberWithCommas(amount / 100)}{" "}
          {status === "Paused"
            ? "is paused."
            : `will be processed ${nextDateString}`}
        </Text>
        <EditButton>
          <FnrIcon fad fa-pencil />
        </EditButton>
      </Wrapper>
    </ActionButtonLayout>
  );
}

const Wrapper = styled.div`
  padding: 0px 20px 0px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Text = styled.div`
  text-transform: uppercase;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
`;
const EditButton = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  font-size: 20px;
  transition: opacity 0.2s, transform 0.2s;
  opacity: 0.5;
  transform: scale(0.9);
  cursor: pointer;
  &:hover {
    opacity: 1;
    transform: none;
  }
  &:active {
    opacity: 1;
    transform: scale(0.9);
  }
`;
const PausedIcon = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  font-size: 20px;
`;
